/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerFindAllVersionsQueryResponse, PromptsControllerFindAllVersionsPathParams, PromptsControllerFindAllVersions401, PromptsControllerFindAllVersions403, PromptsControllerFindAllVersions404 } from "../../models/promptsController/PromptsControllerFindAllVersions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { promptsControllerFindAllVersions } from "../../clients/promptsService/promptsControllerFindAllVersions";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const promptsControllerFindAllVersionsQueryKey = (id: PromptsControllerFindAllVersionsPathParams["id"]) => [{
  url: '/api/v1/prompts/:id/versions',
  params: {
    id: id
  }
}] as const;
export type PromptsControllerFindAllVersionsQueryKey = ReturnType<typeof promptsControllerFindAllVersionsQueryKey>;
export function promptsControllerFindAllVersionsQueryOptions(id: PromptsControllerFindAllVersionsPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = promptsControllerFindAllVersionsQueryKey(id);
  return queryOptions<PromptsControllerFindAllVersionsQueryResponse, ResponseErrorConfig<PromptsControllerFindAllVersions401 | PromptsControllerFindAllVersions403 | PromptsControllerFindAllVersions404>, PromptsControllerFindAllVersionsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return promptsControllerFindAllVersions(id, config);
    }
  });
}

/**
 * @summary Get all versions of a prompt
 * {@link /api/v1/prompts/:id/versions}
 */
export function usePromptsControllerFindAllVersions<TData = PromptsControllerFindAllVersionsQueryResponse, TQueryData = PromptsControllerFindAllVersionsQueryResponse, TQueryKey extends QueryKey = PromptsControllerFindAllVersionsQueryKey>(id: PromptsControllerFindAllVersionsPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<PromptsControllerFindAllVersionsQueryResponse, ResponseErrorConfig<PromptsControllerFindAllVersions401 | PromptsControllerFindAllVersions403 | PromptsControllerFindAllVersions404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? promptsControllerFindAllVersionsQueryKey(id);
  const query = useQuery({
    ...promptsControllerFindAllVersionsQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PromptsControllerFindAllVersions401 | PromptsControllerFindAllVersions403 | PromptsControllerFindAllVersions404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}